import { Box, Button, Tooltip, Typography } from "@mui/material";
import React from "react";
import DraftsIcon from "@mui/icons-material/Drafts";
import { Link } from "react-router-dom";
import { useTheme } from "../../style/theme";
const CreateNewDocument = () => {
  const theme = useTheme();
  return (
<Box
      sx={{
        border: `1px solid ${theme.mode === "dark" ? "#292929" : "#D6D6D6"}`,
        borderRadius: "5px",
        minHeight: "230px",
        textAlign: "center",
        // px: { xs: 2, sm: 4, md: 6 }, // horizontal padding responsive
        py: { xs: 4, sm: 6, md: 8 }, // vertical padding responsive
        mx: "auto", // center horizontally if in a flex or grid layout
        width:"full", // limit width for large screens
      }}
    >
      <DraftsIcon sx={{ fontSize: 40, mb: 1 }} />
      <Typography variant="body1">
        No matches found for your current search.
      </Typography>
      <Box mt={3}>
        <Link to="/">
          <Tooltip title="Create new Document" arrow placement="right">
            <Button variant="contained">Create new Document</Button>
          </Tooltip>
        </Link>
      </Box>
    </Box>
  );
};

export default CreateNewDocument;
